// extracted by mini-css-extract-plugin
export default {"spinner":"voucher-batch_spinner__MFn49"};